export let Loading = "cart/Loading";
export let Error = "cart/Error";
export let AddInCart = "cart/data";
export let AddInWishList = "add/wishlist";
export let DelfromWishlist = "del/wishlist";
export let GetwishlistData = "get/wishlist";
export let GetCart = "get/cartdata";
export let GetorderData = "get/orderdata";
